module.exports = __webpack_public_path__ + "static/img/task_example.720181a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/task_example.png
// module id = CPSo
// module chunks = 4